import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export default function PreviewApplyPage() {
  useDocumentTitle('Apply — apply pub');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pt: 8, px: 2 }}>
      <Typography
        sx={{
          color: '#9CA3AF',
          fontSize: 15,
          mb: 4,
          textAlign: 'center',
        }}
      >
        Find and complete any application process.
      </Typography>

      {/* Search input */}
      <Box
        sx={{
          width: '100%',
          maxWidth: 520,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          border: '1px solid #E0D8D0',
          borderRadius: 100,
          bgcolor: '#FFFFFF',
          px: 2.5,
          py: 1.25,
        }}
      >
        <SearchIcon sx={{ color: '#9CA3AF', fontSize: 20 }} />
        <input
          placeholder="Search applications..."
          style={{
            flex: 1,
            border: 'none',
            outline: 'none',
            fontSize: 15,
            fontFamily: 'Roboto, sans-serif',
            color: '#374151',
            backgroundColor: 'transparent',
          }}
        />
      </Box>

      <Typography
        sx={{
          color: '#9CA3AF',
          fontSize: 13,
          mt: 3,
          textAlign: 'center',
        }}
      >
        Browse published application processes from organizations.
      </Typography>
    </Box>
  );
}
